module.exports = __webpack_public_path__ + "media/cover-image.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/media/editor/blocks/cover-image.jpg
// module id = 3441
// module chunks = 0